<template>
  <Select
    class="vehicle-type__select"
    :placeholder="placeholder"
    :is-disabled="isDisabled"
    :value="selectedVehicleTypeId"
    :options="vehicleTypes"
    :empty-text="emptyStateText"
    value-key="external_id"
    label-key="name"
    @beforeChange="onBeforeChange"
    @change="handleVehicleTypeSelect"
  >
    <template #option="{ option }">
      <p v-if="option" class="vehicle-type-option__info-text">
        {{ option.name }}
      </p>
    </template>
  </Select>
</template>

<script>
import { Select } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Виберіть тип транспортного засобу',
    },
    vehicleTypes: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      selectedVehicleTypeId: null,
    };
  },
  mounted() {
    if (this.vehicleTypes?.length === 1) {
      this.handleVehicleTypeSelect(this.vehicleTypes[0]?.id);
    }
  },
  components: { Select },
  methods: {
    handleVehicleTypeSelect(selectedId) {
      const selectedVehicleType = this.vehicleTypes.find(vehicle => vehicle.external_id === selectedId);
      this.selectedVehicleTypeId = selectedVehicleType ? selectedId : null;
      this.$emit('input', selectedVehicleType || null);
      this.$emit('change', selectedVehicleType || null);
    },
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          const newId = typeof newValue === 'object' ? newValue?.external_id : newValue;
          if (this.selectedVehicleTypeId !== newId) {
            this.selectedVehicleTypeId = newId;
          }
        }
      },
    },
    vehicleTypes: {
      handler() {
        if (this.vehicleTypes?.length === 1 && this.selectedVehicleTypeId !== this.vehicleTypes[0]?.external_id) {
          this.handleVehicleTypeSelect(this.vehicleTypes[0]?.external_id);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.vehicle-type__select {
  width: 100%;
}

.vehicle-type-option__info-text {
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  strong {
    font-weight: 600;
  }
}
</style>
